// src/components/store/sections/faqs/FaqV93TwocolumnboxSlateGold.tsx
"use client";

import React from "react";
import DynamicFaqVariant from "./DynamicFaqVariant";

export default function FaqV93TwocolumnboxSlateGold(props: any) {
  return (
    <DynamicFaqVariant
      variantNumber={93}
      archKey="two_column_box"
      archLabel="Two-Column Split Grid"
      palName="SlateGold"
      grad="from-slate-800 via-zinc-900 to-neutral-950"
      lightBg="bg-amber-50/80"
      textCol="text-amber-700"
      borderCol="border-amber-300"
      btnCls="bg-slate-900 hover:bg-slate-800"
      hexCol="#eab308"
      {...props}
    />
  );
}
